import React, {useState, useCallback, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';

import { CREATE_BUYER_USER } from './queries';
import { ButtonContainer } from './elements';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewBuyerUser = ({ knownBuyerId, setShowModal, refetch }) => {
  const [submitting, setSubmitting] = useState();
  const buyerId = useParams().buyerId || knownBuyerId;
  const [createBuyerUser] = useMutation(CREATE_BUYER_USER, {
    onCompleted: () => {
      if (refetch) { refetch(); }
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    createBuyerUser({ variables: input });
  });

  const { control, handleSubmit, register, watch, formState: { errors } } = useForm({
    defaultValues: {
      buyerId: buyerId,
      firstName: '',
      lastName: '',
      email: '',
      role: 'Admin',
    }
  });

  return (
    <View>
      {/* <SubNav /> */}
      {submitting ?
        DataState.Loading :
        <View>
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
            id="email"
            {...register("email", {
              required: "Required",
              validate: {
                maxLength: (v) =>
                  v.length <= 50 || "Email should have at most 50 characters",
                matchPattern: (v) => EMAIL.test(v) ||
                  "Must be a valid email address",
              },
            })}
          />
          <Input.Text
            label="First Name:"
            name="firstName"
            control={control}
            errors={errors}
            {...register("firstName", {
              required: "Required"
            })}
          />
          <Input.Text
            label="Last Name:"
            name="lastName"
            control={control}
            errors={errors}
            {...register("lastName", {
              required: "Required"
            })}
          />
          <Input.Picker
            label="Role:"
            name="role"
            options={[
              { value: 'Admin', label: 'Admin' },
              { value: 'Normal', label: 'Normal' },
            ]}
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Buyer User" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewBuyerUser;
